import { CLienteAPi } from "../../client_api";

export class User_types_request {
    ConexionIacpos: number;
    clienteAPI: CLienteAPi;
    pkId: string;
}